// Typelizer digest d80158de4a9294e7ab69e810cdfd9e62
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /accountant/firm/engagements/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/accountant/firm/engagements/:id', params, options),
    method: 'delete',
  }),
}
